export default "__VITE_ASSET__C1rmn2_6__"